// extracted by mini-css-extract-plugin
export default {"buttons":"styles__buttons___lnKrb"};